import axios from "axios";
import {BackendExceptionMessage} from "./api/model/BackendExceptionMessage";

export const javaBackendAxios = axios.create({
    timeout: 900_000,
    timeoutErrorMessage: "TIMEOUT"
});

javaBackendAxios.interceptors.response.use(
    response => response,
    error => {
        error.response.data =  error.response.data as BackendExceptionMessage;
        console.log("API Error: " + JSON.stringify(error.response.data))
       throw error;
    });

export default javaBackendAxios;
